import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * A fade in component.
 * @author Dayne Coulson-Hoffacker
 */
export default class InView {
  /**
   * Constructs a new section.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   * @param {Hurdler} options.hurdler - Hurdler instance.
   */
  constructor (options) {
    this.element = options.element
    this.globalHeader = document.querySelector('[data-component="global-header"]')
    const self = this
    // new Waypoint({
    //   element: self.element,
    //   handler: () => {
    //     if (self.element.classList.contains('green-bg')) {
    //       self.globalHeader.classList.toggle('dark')
    //     }
    //     if (self.element.classList.contains('cream')) {
    //       self.globalHeader.classList.toggle('dark')
    //     }
    //   },
    //   offset: '10%'
    // })
    new Waypoint({
      element: self.element,
      handler: () => {
        self.element.classList.toggle('visible')
        // if (self.element.classList.contains('main')) {
        //   self.globalHeader.classList.toggle('dark')
        // }
      },
      offset: '10%'
    })
  }
}



// WEBPACK FOOTER //
// ./components/in-view/index.js